package com.tregz.tremenz.ui.icon

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.painter.Painter

import org.jetbrains.compose.resources.painterResource
import tregz.tremenz.shared.generated.resources.Res
import tregz.tremenz.shared.generated.resources.ic_beer
import tregz.tremenz.shared.generated.resources.ic_cocktail
import tregz.tremenz.shared.generated.resources.ic_collapse
import tregz.tremenz.shared.generated.resources.ic_contact
import tregz.tremenz.shared.generated.resources.ic_dark_mode
import tregz.tremenz.shared.generated.resources.ic_expand
import tregz.tremenz.shared.generated.resources.ic_info
import tregz.tremenz.shared.generated.resources.ic_instant_mix
import tregz.tremenz.shared.generated.resources.ic_library_video
import tregz.tremenz.shared.generated.resources.ic_light_mode
import tregz.tremenz.shared.generated.resources.ic_media_output
import tregz.tremenz.shared.generated.resources.ic_news
import tregz.tremenz.shared.generated.resources.ic_pause
import tregz.tremenz.shared.generated.resources.ic_photos
import tregz.tremenz.shared.generated.resources.ic_play
import tregz.tremenz.shared.generated.resources.ic_queue_music
import tregz.tremenz.shared.generated.resources.ic_radio
import tregz.tremenz.shared.generated.resources.ic_tremenz
import tregz.tremenz.shared.generated.resources.ic_tv
import tregz.tremenz.shared.generated.resources.ic_wine
import tregz.tremenz.shared.generated.resources.ic_wordmark

@Composable
fun iconPainter(key: IconKey): Painter = painterResource(
    when (key) {
        IconKey.BEER -> Res.drawable.ic_beer
        IconKey.COCKTAIL -> Res.drawable.ic_cocktail
        IconKey.COLLAPSE -> Res.drawable.ic_collapse
        IconKey.CONTACT -> Res.drawable.ic_contact
        IconKey.DAY -> Res.drawable.ic_light_mode
        IconKey.EXPAND -> Res.drawable.ic_expand
        IconKey.INFO -> Res.drawable.ic_info
        IconKey.INSTANT_MIX -> Res.drawable.ic_instant_mix
        IconKey.MUSIC -> Res.drawable.ic_queue_music
        IconKey.NEWS -> Res.drawable.ic_news
        IconKey.NIGHT -> Res.drawable.ic_dark_mode
        IconKey.OUTPUT -> Res.drawable.ic_media_output
        IconKey.PAUSE -> Res.drawable.ic_pause
        IconKey.PHOTOS -> Res.drawable.ic_photos
        IconKey.PLAY -> Res.drawable.ic_play
        IconKey.RADIO -> Res.drawable.ic_radio
        IconKey.TREMENZ -> Res.drawable.ic_tremenz
        IconKey.TV -> Res.drawable.ic_tv
        IconKey.VIDEO -> Res.drawable.ic_library_video
        IconKey.WINE -> Res.drawable.ic_wine
        IconKey.WORDMARK -> Res.drawable.ic_wordmark
    }
)
